module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tags/tags.component.css
// module id = ./src/app/components/tags/tags.component.css
// module chunks = main